<script>
    import Nav from "../components/navigation.svelte"
    import Profile from "../components/skills.svelte"
</script>

<Nav/>

<section>

    <Profile/>

</section>

<style>
    section {
        width: 100%;
    }
</style>